import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  leftSidebarWidth,
  leftSidebarToolsWidth,
  headerHeight
} from '../../Constants'

export interface OpenLayersMapStyleProps {
  bottomBarOpen: boolean
  bottomBarHeight: number
  rightSideBarWidth: number
}

export const openLayersMapStyle = makeStyles<Theme, OpenLayersMapStyleProps>(theme => ({
  root: {
    display: 'flex',
    height: `calc(100vh - ${headerHeight}px)`,
    background: theme.palette.common.white,
    '& .ol-rotate': {
      backgroundColor: '#00000000',
      top: theme.spacing(3),
      right: theme.spacing(3)
    },
    '& .ol-rotate-reset': {
      backgroundColor: '#00000000',
      color: '#00000000',
      '&:hover': {
        backgroundColor: '#00000000'
      },
      '&:focus': {
        backgroundColor: '#00000000'
      }
    },
    '& .ol-zoom': {
      backgroundColor: `${theme.palette.primary.main}6d`,
      top: 'auto',
      left: 'auto',
      right: theme.spacing(3),
      bottom: theme.spacing(4),
      '@media(-webkit-min-device-pixel-ratio: 2)': {
        bottom: theme.spacing(8)
      }
    },
    '& .ol-zoom button': {
      width: 30,
      height: 30
    },
    '& .ol-zoom-in': {
      cursor: 'pointer',
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      },
      '&:focus': {
        backgroundColor: theme.palette.primary.main
      },
      '&:active': {
        backgroundColor: theme.palette.primary.light
      }
    },
    '& .ol-zoom-out': {
      cursor: 'pointer',
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      },
      '&:focus': {
        backgroundColor: theme.palette.primary.main
      },
      '&:active': {
        backgroundColor: theme.palette.primary.light
      }
    },
    '& .ol-scale-line': {
      left: leftSidebarToolsWidth + theme.spacing(3),
      bottom: theme.spacing(4),
      backgroundColor: theme.palette.primary.main,
      border: `solid ${theme.palette.primary.main}8d`,
      backgroundClip: 'padding-box',
      '@media(-webkit-min-device-pixel-ratio: 2)': {
        bottom: theme.spacing(8)
      }
    }
  },
  bottomBarOpen: {
    '& .ol-zoom': {
      bottom: props => props.bottomBarHeight + theme.spacing(4.5),
      '@media(-webkit-min-device-pixel-ratio: 2)': {
        bottom: props => props.bottomBarHeight + theme.spacing(9)
      }
    },
    '& .ol-scale-line': {
      bottom: props => props.bottomBarHeight + theme.spacing(4.5),
      '@media(-webkit-min-device-pixel-ratio: 2)': {
        bottom: props => props.bottomBarHeight + theme.spacing(9)
      }
    },
    '& #mousePositionWrapper': {
      bottom: props => props.bottomBarHeight + theme.spacing(0.8)
    },
    '& #copyrightWrapper': {
      bottom: props => props.bottomBarHeight + theme.spacing(0.8)
    }
  },
  bottomBarClosed: {
    '& #mousePositionWrapper': {
      bottom: 0
    },
    '& #copyrightWrapper': {
      bottom: 0
    }
  },
  leftSideBarOpen: {
    '& .ol-scale-line': {
      left: leftSidebarWidth + leftSidebarToolsWidth + theme.spacing(3)
    },
    '& #copyrightWrapper': {
      left: leftSidebarWidth + leftSidebarToolsWidth + theme.spacing(3)
    }
  },
  leftSideBarClosed: {
    '& #copyrightWrapper': {
      left: theme.spacing(10)
    }
  },
  rightSideBarOpen: {
    '& .ol-rotate': {
      right: props => props.rightSideBarWidth + theme.spacing(3)
    },
    '& .ol-zoom': {
      right: props => props.rightSideBarWidth + theme.spacing(3)
    },
    '& #mousePositionWrapper': {
      right: props => props.rightSideBarWidth + theme.spacing(3)
    }
  },
  rightSideBarClosed: {
    '& #mousePositionWrapper': {
      right: theme.spacing(3)
    }
  },
  northIcon: {
    height: theme.spacing(4),
    cursor: 'pointer'
  },
  copyrightWrapper: {
    position: 'absolute',
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
    borderRadius: 2,
    zIndex: 500
  },
  copyrightItem: {
    marginRight: theme.spacing(1),
    textDecoration: 'none',
    color: theme.palette.common.black
  },
  copyright: {
    fontSize: 9,
    margin: 0,
    padding: 0,
    color: theme.palette.common.white
  },
  mousePositionWrapper: {
    position: 'absolute',
    minWidth: theme.spacing(28.125),
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    backgroundColor: theme.palette.common.white,
    borderRadius: 2,
    zIndex: 500
  },
  mousePosition: {
    fontSize: 10,
    margin: 0,
    padding: 0
  },
  mousePositionCoordinateSystem: {
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(1)
  }
}))
